export default __webpack_public_path__ + "static/media/Supplier_Product_Promotion_0210_1510_2025.af3f097f.xlsx";